(function () {
    'use strict';

    angular
        .module('app')
        .controller('UsersListController', UsersListController);

    UsersListController.$inject = ['API', 'alert', 'debug', '$stateParams', 'ListViewSearchExtension', 'i18n', '$q',];

    function UsersListController(API, alert, debug, $stateParams, ListViewSearchExtension, i18n, $q) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = {
            user_type: '',
            language: '',
            sort: 'latestFirst',
            provider: '',
            interval: '',
            price: '',
            children: '',
        };
        vm.loadingState = {
            userIsLoading: false
        };
        vm.users = [];

        vm.statuses = [
            'trialing',
            'active',
            'inactive',
            'canceled',
            'past_due',
            'test',
        ];

        vm.intervals = {
            1: '',
            6: '',
            12: '',
        };

        vm.openRemoveModal = openRemoveModal;
        vm.keyUp = keyUp;
        vm.loadResources = loadResources;
        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }
            loadResources(true);

            $q.all([i18n.get('INTERVAL_1_MONTH'), i18n.get('INTERVAL_6_MONTHS'), i18n.get('INTERVAL_12_MONTHS')])
                .then(function(texts) {
                    vm.intervals[1] = texts[0];
                    vm.intervals[6] = texts[1];
                    vm.intervals[12] = texts[2];
                });
        }

        function openRemoveModal(user) {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.User.recycle({ id: user.id }).$promise;

                removePromise.then(function() {
                    var index = vm.users.findIndex(function(item) {
                        return item.id === user.id;
                    });
                    vm.users.splice(index, 1);
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('USER_RECYCLED') });
                }, function() {});
            }, function() {});
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'expand': 'loginTeacher,loginStudent,loginThirdparty,loginIusadmin,groups,school,subscription,lastLogin,subscriptionPlans',
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
            };

            if (vm.listObject.filter.sort) {
                switch (vm.listObject.filter.sort) {
                    case 'latestFirst':
                        searchObject.sort = '-created_time';
                        break;
                    case 'oldestFirst':
                        searchObject.sort = 'created_time';
                        break;
                    case 'latestLoginFirst':
                        searchObject.sort = '-logins.created';
                        break;
                    case 'oldestLoginFirst':
                        searchObject.sort = 'logins.created';
                        break;
                    case 'licenseExpiryAsscending':
                        searchObject.sort = 'groups.license_expiry';
                        break;
                    case 'licenseExpiryDescending':
                        searchObject.sort = '-groups.license_expiry';
                        break;

                    default:
                        break;
                }
            }

            if (vm.listObject.filter.user_type) {
                searchObject.user_type = vm.listObject.filter.user_type;
            }

            if (vm.listObject.filter.language) {
                searchObject.language = vm.listObject.filter.language;
            }

            if (vm.listObject.filter.provider) {
                searchObject.subscriptions__provider = vm.listObject.filter.provider;
            }

            if (vm.listObject.filter.status) {
                searchObject.subscriptions__status = vm.listObject.filter.status;
            }

            if (vm.listObject.filter.interval) {
                searchObject.subscriptionPlans__recurrence_months = vm.listObject.filter.interval;
            }

            if (vm.listObject.filter.price) {
                searchObject.subscriptionPlans__price = vm.listObject.filter.price;
            }

            if (vm.listObject.filter.children) {
                searchObject.subscriptionPlans__children = vm.listObject.filter.children;
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.User.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.User.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.userIsLoading = true;
                promise.then(function (response) {
                    vm.users = response.items;
                    debug.log(response);
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.userIsLoading = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                vm.loadResources(true);
            }
        }
    }
})();